import { Mail } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { InvitationForm } from '@/components/InvitationForm';
import { InvitationsList } from '@/components/InvitationsList';

interface InvitationsTabProps {
  refreshTrigger: number;
  onInvitationSent: () => void;
}

export const InvitationsTab = ({ refreshTrigger, onInvitationSent }: InvitationsTabProps) => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-center space-x-2">
        <Mail className="h-5 w-5" />
        <h2 className="mobile-subheading">User Invitations</h2>
      </div>
      
      <Tabs defaultValue="send" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="send">Send Invitation</TabsTrigger>
          <TabsTrigger value="manage">Manage Invitations</TabsTrigger>
        </TabsList>
        
        <TabsContent value="send" className="mt-6">
          <InvitationForm onInvitationSent={onInvitationSent} />
        </TabsContent>
        
        <TabsContent value="manage" className="mt-6">
          <InvitationsList refreshTrigger={refreshTrigger} />
        </TabsContent>
      </Tabs>
    </div>
  );
};
